// extracted by mini-css-extract-plugin
export default {"parent":"CuentaCard_parent__A6aNR","parentBody":"CuentaCard_parentBody__Izu-m","child":"CuentaCard_child__20HPn"};